import { useState } from 'react';

/**
 * Custom hook for form state management
 */
export const useFormState = () => {
  const [stakingStep, setStakingStep] = useState<'idle' | 'approving' | 'staking' | 'claiming' | 'unstaking' | 'extending'>('idle');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [stakeAmount, setStakeAmount] = useState('');
  const [lockDays, setLockDays] = useState(30); // Default 30 days
  const [selectedStakeId, setSelectedStakeId] = useState<number | null>(null);

  const clearForms = () => {
    setStakeAmount('');
    setErrorMessage(null);
  };

  const resetStakingState = () => {
    setStakingStep('idle');
    setSelectedStakeId(null);
  };

  return {
    stakingStep,
    setStakingStep,
    errorMessage,
    setErrorMessage,
    stakeAmount,
    setStakeAmount,
    lockDays,
    setLockDays,
    selectedStakeId,
    setSelectedStakeId,
    clearForms,
    resetStakingState,
  };
};
